import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import * as passagesApi from '../api/passages';

/**
 * Query for the current round's passage
 */
export const usePassage = (gameId, roundId) => {
  return useQuery({
    queryKey: ['passage', gameId, roundId],
    queryFn: () => passagesApi.getPassage(gameId, roundId),
    enabled: !!gameId && !!roundId,
  });
};

/**
 * Mutation for saving passage draft
 */
export const useUpdatePassage = (gameId, roundId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) => passagesApi.updatePassage(gameId, roundId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['passage', gameId, roundId] });
    },
  });
};

/**
 * Mutation for publishing passage
 */
export const usePublishPassage = (gameId, roundId) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => passagesApi.publishPassage(gameId, roundId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['passage', gameId, roundId] });
      queryClient.invalidateQueries({ queryKey: ['passages', gameId] });
      queryClient.invalidateQueries({ queryKey: ['round', gameId] });
      queryClient.invalidateQueries({ queryKey: ['currentRound', gameId] });
    },
  });
};

/**
 * Query for all published passages (story viewer)
 */
export const useAllPassages = (gameId, sceneId = null) => {
  return useQuery({
    queryKey: ['passages', gameId, sceneId],
    queryFn: () => passagesApi.getAllPassages(gameId, sceneId),
    enabled: !!gameId,
  });
};

/**
 * Query for a specific passage by number
 */
export const usePassageByNumber = (gameId, number) => {
  return useQuery({
    queryKey: ['passage', gameId, 'number', number],
    queryFn: () => passagesApi.getPassageByNumber(gameId, number),
    enabled: !!gameId && !!number,
  });
};
